export default "__VITE_ASSET__C58eoW0L__"